module.exports = __webpack_public_path__ + "img/pin.1542160f.svg";